import React,{Fragment, useState, useEffect} from 'react'
import Form from './components/Form';

function App() {
let component;

const [searchText, saveSearchText] = useState('');
const [result,saveResult] = useState({});
const [totalPages,saveTotalPages]=useState(0);
const [currentPage,saveCurrentPage]=useState(0);






  return (
   <Fragment>
    <div className='container'>
      <Form
        searchText={searchText}
        saveSearchText={saveSearchText}
        saveResult={saveResult}
        totalPages={totalPages}
        saveTotalPages={saveTotalPages}
        currentPage={currentPage}
       
       
      />
    
    </div>
    

   </Fragment>
  );
}

export default App;
